import React from 'react'

const ReturnContainer = () => (
  <div className="has-Header Container">
    <p>for ReturnContainer</p>
    <div>Catalog Header
      <p> search goods</p>
      <p> register goods to button</p>
    </div>
    <div>
      <p> Catalog List</p>
    </div>
  </div>
)

export default ReturnContainer



// WEBPACK FOOTER //
// ./src/ReturnGoods/containers/ReturnContainer.js